import React from 'react';

export type CheckIconProps = {
  size?: number;
  strokeWidth?: number;
  color?: string; // defaults to currentColor
  className?: string;
  style?: React.CSSProperties;
  'aria-hidden'?: boolean | 'true' | 'false';
};

const CheckIcon: React.FC<CheckIconProps> = ({ size = 18, strokeWidth = 2, color, className, style, ...rest }) => {
  const finalStyle = color ? { color, ...style } : style;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={finalStyle}
      {...rest}
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  );
};

export default CheckIcon;
